import React from "react";
import { Card, CardContent, Typography, Grid, Box, Button } from "@mui/material";
import image1 from "../assets/jeeimage.webp";
import image2 from "../assets/neetimage.webp";
import image3 from "../assets/scholarshipimage.webp";

const resultsData = [
    {
        title: "JEE (Main) 2025 Results",
        image: image1,
        students: [
            { name: "Shreyas Lohiya", score: "100 Percentile", program: "AICP" },
            { name: "Harsh Jha", score: "100 Percentile", program: "AICP" },
            { name: "Krishna Agarwal", score: "99.99 Percentile", program: "Classroom Program" },
        ],
    },
    {
        title: "NEET 2024 Results",
        image: image2,
        students: [
            { name: "Mridul Manya Anand", score: "1 AIR", program: "(3 Year Classroom) Marks - 720/720" },
            { name: "Ayush Naugria", score: "1 AIR", program: "(2 Year Classroom) Marks - 720/720" },
            { name: "Arghyadeep Dutta", score: "1 AIR", program: "(2 Year Classroom) Marks - 720/720" },
        ],
    },
    {
        title: "Olympiads & Scholarship Exam Results",
        image: image3,
        students: [
            { name: "Zaman Hussain", score: "", program: "NSEA/C/P RMO-2023" },
            { name: "Mohit Shekhar Shukla", score: "", program: "IOQM 2023" },
            { name: "Piyush Dhakar", score: "", program: "NSEJS 2023" },
        ],
    },
];

const OutstandingResults = () => {
    return (
        <Box textAlign="center" p={{ xs: 2, md: 4 }}>
            <Typography variant="h5" fontWeight="bold" mb={3}>
                Outstanding Results
            </Typography>
            <Grid container spacing={2} justifyContent="center">
                {resultsData.map((category, index) => (
                    <Grid item key={index} xs={12} sm={6} md={4}>
                        <Card sx={{ borderRadius: 2, boxShadow: 3, height: { xs: 'auto', md: '360px' } }}>
                            <Box sx={{ position: "relative" }}>
                                <Box sx={{
                                    position: "absolute",
                                    top: 0,
                                    width: "100%",
                                    backgroundColor: "rgba(3, 169, 244, 0.8)",
                                    color: "white",
                                    py: 2,
                                    textAlign: "center",
                                    fontSize: { xs: "0.9rem", md: "1.2rem" }
                                }}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {category.title}
                                    </Typography>
                                </Box>
                            </Box>
                            <CardContent>
                                <Grid container spacing={2} justifyContent="center" sx={{ mt: 7 }}>
                                    <img src={category.image} alt={category.title} style={{ width: "100%", borderRadius: "8px 8px 0 0" }} />
                                </Grid>
                            </CardContent>
                            <Box textAlign="center" py={2}>
                                <Button sx={{ color: "#03A9F4", fontWeight: "bold", fontSize: { xs: "0.8rem", md: "1rem" } }}>
                                    See all results
                                </Button>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default OutstandingResults;
